import React, { useState } from 'react';
import { User } from '../../types/auth';
import Balances from './Balances';
import Transfers from './Transfers';
import Rewards from './Rewards';
import History from './History';
import Statements from './Statements';
import TaxCenter from './TaxCenter';
import Security from './Security';
import Privacy from './Privacy';
import Settings from './Settings';
import Support from './Support';

interface ProfilePageProps {
  user: User;
}

const MENU_ITEMS = [
  { id: 'balances',   label: '💰 Balances' },
  { id: 'transfers',  label: '🔄 Transfers' },
  { id: 'rewards',    label: '🎁 Rewards' },
  { id: 'history',    label: '📋 History' },
  { id: 'statements', label: '📄 Statements' },
  { id: 'tax',        label: '🧾 Tax Center' },
  { id: 'security',   label: '🔒 Security' },
  { id: 'privacy',    label: '🛡️ Privacy' },
  { id: 'settings',   label: '⚙️ Settings' },
  { id: 'support',    label: '❓ Support' },
] as const;

type MenuId = typeof MENU_ITEMS[number]['id'];

export default function ProfilePage({ user }: ProfilePageProps) {
  const [active, setActive] = useState<MenuId>('balances');

  const renderContent = () => {
    switch (active) {
      case 'balances':   return <Balances />;
      case 'transfers':  return <Transfers />;
      case 'rewards':    return <Rewards />;
      case 'history':    return <History />;
      case 'statements': return <Statements />;
      case 'tax':        return <TaxCenter />;
      case 'security':   return <Security />;
      case 'privacy':    return <Privacy />;
      case 'settings':   return <Settings user={user} />;
      case 'support':    return <Support />;
      default:           return null;
    }
  };

  const displayName =
    user.email ||
    (user.walletAddress
      ? `${user.walletAddress.slice(0, 6)}…${user.walletAddress.slice(-4)}`
      : 'My Account');

  return (
    <div className="profile-page">
      <div className="profile-sidebar">
        <div className="profile-avatar">
          <span className="profile-avatar-icon">👤</span>
          <span className="profile-display-name">{displayName}</span>
        </div>
        <nav className="profile-nav">
          {MENU_ITEMS.map(item => (
            <button
              key={item.id}
              className={`profile-nav-item${active === item.id ? ' profile-nav-active' : ''}`}
              onClick={() => setActive(item.id)}
            >
              {item.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="profile-content">
        {renderContent()}
      </div>
    </div>
  );
}
